// Colors constants that match the CSS variables defined in colors.css
export const colors = {
  primary: '#4A5559',
  secondary: '#D9B471',
  lightBrown: '#faf4eb',
  border: '#c8ccd2',
  lightBorder: '#c8ccd250',
  black: '#000000',
  white: '#FFFFFF',
  red: '#df2224',
  green: '#17BF52',
  darkRed: '#F20505',
  lightRed: '#ff4d4d',
  offWhite: '#F2F2F2',
  grayText: '#595954',
  lightOrange: '#F24405',
  darkGreen: '#118C76',
  lightGray: '#BFBFBF',
  placeholderText: '#4242427F',
  transparentBlack: 'rgba(0,0,0,0.25)',
  grey: '#6D6D6D',
  yellow: '#FFD700',
  lightGray2:'#f0f0f0',
  lightGreen: '#D4F4D4',
  lightOrangeBg: '#FFE4D6',
  lightRedBg: '#FFE6E6',
  lightSecondary: '#F5E6D1',
  shadow: 'rgba(0, 0, 0, 0.1)',
  pink:'#e81e63',
  blue:'#1976d2'
}; 